// 各ローン種類の表示
import React from 'react';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import Heading from './Heading';

interface Props {
  name: string;
  text: string;
  type: string;
  is_new_line?: boolean;
  application_btn_func: () => void;
}

const LoanSelect: React.FC<Props> = ({ name, text, type, is_new_line, application_btn_func }) => {
  return (
    <section className="loan-section">
      <Heading label={name} size="m" css_class="-base" is_new_line={is_new_line} />
      <Annotation text={text} />
      <CenterButton
        label="お申込みはこちら"
        btn_class={`arrow-right btn-${type}-color`}
        handleClick={application_btn_func}
      />
    </section>
  );
};

export default LoanSelect;
